export default __webpack_public_path__ + "static/media/jobs-benefits-family-photo.2014b829.png";